

export class AuthService {
  static async getAt(): Promise<string | null> {
    if(sessionStorage.getItem('activated') !== "true" && localStorage.getItem('hasEnabledWc') !== "true") {
      const match = document.cookie.match(`(^|;) *at=([^;]*)`) || '';
      return Promise.resolve(match[2] || null);
    }
    console.log("here")
    await customElements.whenDefined('tranciti-navbar');
    await (window as any)._getCookies()
    return Promise.resolve(await (window as any)._getAuthToken());
  }
}
